<template>
	<div>
		<form @submit.prevent="filterTestRuns">
			<div class="form-group">
				<label for="fromDate">From Date</label>
				<input
					type="date"
					required
					class="form-control"
					name="fromDate"
					:placeholder="today"
					v-model="fromDate"
				/>
			</div>
			<div class="form-group">
				<label for="toDay">To Date</label>
				<input
					type="date"
					required
					class="form-control"
					name="toDate"
					:placeholder="today"
					v-model="toDate"
				/>
			</div>
			<div class="d-flex justify-content-end">
				<button type="submit" class="btn btn-primary">Search</button>
			</div>
		</form>
		<div class="mt-2">
			<h5>Test Runs Found</h5>
			<Loading v-if="loading" :showText="true"/>
			<ErrorAlert v-else-if="error" :error="error"/>
			<table v-else-if="testRunsList.length > 0" class="table mt-3 test-runs-table">
				<thead>
					<tr>
						<th>Run ID</th>
						<th>Date</th>
						<th>Total Duration</th>
						<th>Status</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(testRun, index) in testRunsList" :key="index" :class="{'selected-run': selectedTestRun && testRun.runId === selectedTestRun}">
						<td>{{testRun.runId}}</td>
						<td>{{ formatDate(testRun.startedAt) }}</td>
						<td>{{ convertDuration(testRun.duration)}}</td>
						<td :class="STATUS_CLASSES[testRun.status]">{{testRun.status}}</td>
						<td>
							<button
								title="Info"
								class="btn btn-secondary"
								@click="selectTestRun(testRun.runId)"
							>
								<i class="fas fa-eye"></i>
							</button>
						</td>
					</tr>
				</tbody>
			</table>
			<NoData v-else class="mt-3" />
		</div>
	</div>
</template>

<script>
import NoData from '../shared/NoData';
import TestRunnerService from '../../services/test-runner';
import { formatDate, convertDuration } from '../../util/test-runner';
import { STATUS_CLASSES } from '../../util/test-runner-constants';
import ErrorAlert from '../shared/ErrorAlert';
import Loading from '../shared/Loading';

export default {
	name: 'TestRunnerDashboardSearch',
	props: ['selectedTestRun'],
	components: {
		NoData,
		ErrorAlert,
		Loading
	},
	created() {
		this.formatDate = formatDate;
		this.convertDuration = convertDuration;
		this.STATUS_CLASSES = STATUS_CLASSES;
	},
	mounted() {
		this.getLatestRun();
		this.filterTestRuns();
	},
	data: function() {
		const today = (new Date()).toISOString().split('T')[0];
		return {
			today: today,
			fromDate: today,
			toDate: today,
			testRunsList: [],
			loading: false,
			error: null
		};
	},
	methods: {
		getLatestRun() {
			TestRunnerService.instance().getLatestRun()
				.then((response) => {
					if (response.status == 200 && response.data) {
						this.selectTestRun(response.data.runId);
					}
				});
		},
		filterTestRuns(){
			this.loading = true;
			return TestRunnerService.instance()
				.filterTestRuns(this.fromDate ? this.fromDate + 'T00:00:00' : null, this.toDate ? this.toDate + 'T23:59:59': null)
				.then((response) => {
					if (response.status == 200) {
						if (response.data) {
							this.testRunsList = response.data;
							this.loading = false;
							this.error = null;
						} else {
							this.testRunsList = [];
						}
					} else {
						this.error = "Could not fetch test runs, response status: " + response.status;
					}
				}).catch((err) => {
					this.loading = false;
					this.error = err;
				});

		},
		selectTestRun(runId){
			this.$emit('selectTestRun', runId);
		}
	}
};
</script>

<style scoped>
.test-runs-table tr.selected-run {
	background-color: #facf80;
}
</style>
